<template>
    <div>
    <div v-if="lang" class="agency-card" :class="networkClass">
        
        <div>
            <div class="distance" v-if="agency.distance && maxDistance">
                <span :class="networkClass">{{ lang.labels.distance }}</span>

                <div v-if="maxDistance">
                    <distance-bar
                        :distance="agency.absolute_distance"
                        :label="agency.distance"
                        :max-distance="maxDistance"
                    />
                </div>
            </div>

            <div class="content">
                <slot name="header"></slot>
              
                <div class="header-card-map">
                    <div class="agency-data agency-heading align-items-center pt-0">
                        <div class="row">
                            <div class="col-8">
                                <div class="d-flex">
                                    <img :src="'/img/icons/icon-' + agency.network + '.svg'" :alt="agency.network" width="38" height="35" />

                                    <div class="agency-heading-data">
                                        <div class="business-name">
                                            <span class="affiliate-label">{{ trans('labels.affiliate') }}:</span><br> {{ agency.name }}
                                            <div class="affiliate-desc">{{ agency.address }} <!-- {{ agency.zip_code }} {{ agency.city.title }} ({{ agency.province.id }}) --></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="agency.aicat" class="col-4">
                                <div class="agency-aicat">
                                    <img :src="agency.aicat" class="agency-aicat-img"/>
                                </div>
                            </div>
                        </div>
                       
                        <button
                            v-if="closeButton"
                            class="close-menu"
                            @click="closeCard"
                        >
                            <masked-image src="/img/icons/close.svg" height="20" width="20"></masked-image>
                        </button>
                    </div>
                </div>

                <div class="row card-detail">
                    <div class="col-xl-6 col-4 pr-0 agency-img-zone">
                        <img v-if="agency.url_image" :src="agency.url_image" width="100%" />
                        <img v-else src="/img/img-agency.svg" width="100%" />
                    </div>

                    <div class="agency-data col pl-0">

                        <div class="map-card">

                            <div class="address d-flex align-items-center">
                                <div class="p-2"><masked-image src="/img/icons/map.svg" class="ico_map"></masked-image></div>
                                <div>{{ agency.address }} <!-- {{ agency.zip_code }} {{ agency.city.title }} ({{ agency.province.id }}) --></div>
                            </div>

                            <div class="card-contact">

                                <div v-if="agency.status == 'ATTIVO' || agency.status == 'PRE_SOSPESO'">
                                    <a 
                                    :href="`mailto:${agency.email}`"
                                    class="d-flex align-items-center"
                                    >
                                        <div class="p-2"><masked-image src="/img/icons/email.svg"></masked-image></div>
                                        <div class="email">{{ agency.email }}</div>
                                    </a>
                                </div>

                                <div v-if="agency.whatsapp">
                                    <div class="d-flex align-items-center">
                                        <div class="p-2"><masked-image src="/img/icons/ico_whatsapp.svg"></masked-image></div>
                                        <div class="whatsapp">
                                            <a :href="'https://wa.me/' + this.agency.whatsapp" target="_blank" @click="track('wa')">{{ agency.whatsapp }}</a>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="agency.phone" class="phone-map">
                                    <div class="d-flex align-items-center">
                                        <div class="p-2"><masked-image src="/img/icons/phone-agency.svg" :alt="agency.phone" style="width: 1rem"></masked-image></div>
                                        <div class="phone">{{ agency.phone }}</div>
                                    </div>
                                </div>

                                <div v-if="agency.url_facebook" class="fb-map">
                                    <div class="d-flex align-items-center">
                                        <div class="p-2"><masked-image src="/img/icons/ico_facebook.svg"></masked-image></div>
                                        <div>
                                            <a
                                                v-if="agency.url_facebook"
                                                :href="agency.url_facebook"
                                                target="_blank"
                                                rel="noopener"
                                            >
                                                {{ lang.labels.facebook }}
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="agency.url_instagram" class="fb-map">
                                    <div class="d-flex align-items-center">
                                        <div class="p-2"><masked-image src="/img/icons/ico_instagram.svg"></masked-image></div>
                                        <div>
                                            <a
                                                v-if="agency.url_instagram"
                                                :href="agency.url_instagram"
                                                target="_blank"
                                                rel="noopener"
                                            >
                                                {{ lang.labels.instagram }}
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="agency.url_linkedin" class="fb-map">
                                    <div class="d-flex align-items-center">
                                        <div class="p-2"><masked-image src="/img/icons/ico_linkedin.svg"></masked-image></div>
                                        <div>
                                            <a
                                                v-if="agency.url_linkedin"
                                                :href="agency.url_linkedin"
                                                target="_blank"
                                                rel="noopener"
                                            >
                                                {{ lang.labels.linkedin }}
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="agency.url_twitter" class="fb-map">
                                    <div class="d-flex align-items-center">
                                        <div class="p-2"><masked-image src="/img/icons/ico_twitter.svg"></masked-image></div>
                                        <div>
                                            <a
                                                v-if="agency.url_twitter"
                                                :href="agency.url_twitter"
                                                target="_blank"
                                                rel="noopener"
                                            >
                                                {{ lang.labels.twitter }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="agency-actions col-lg-3">
                        <!-- <modal-opener
                            v-if="canShowLeadForm"
                            name="agency-lead"
                            :data="agency.id"
                        >
                            <a @click.prevent="" class="email">
                                <masked-image src="/img/icons/mail-agency.svg" :alt="agency.email"></masked-image>
                                {{ lang.labels.contact }}
                            </a>
                        </modal-opener> -->

                        <!-- v-if="agency.status == 'ATTIVO' || agency.status == 'PRE_SOSPESO'" -->
                        <a
                            :href="`mailto:${agency.email}`"
                            class="btn btn-contact email"
                            target="_blank"
                            rel="noopener"
                        >
                            <masked-image src="/img/icons/email.svg"></masked-image>
                            <span>{{ agency.email }}</span>
                        </a>

                        <div class="phone-detail">
                            <slot name="phone" v-if="phoneToShow">
                                <button
                                    class="btn btn-network"
                                    :class="'btn-network-' + agency.network"
                                    @click="track('phone')"
                                    v-show="! showPhone"
                                >
                                    <masked-image src="/img/icons/phone-agency.svg" :alt="agency.phone"></masked-image>
                                    {{ lang.labels.telephone }}
                                </button>

                                <a :href="'tel:' + agency.phone" class="btn btn-network" v-show="showPhone">
                                    <masked-image src="/img/icons/phone-agency.svg" :alt="agency.phone"></masked-image>
                                    {{ phoneToShow }}
                                </a>
                            </slot>
                        </div>

                        <template v-if="isActive">
                            <slot name="links">
                                <template v-if="agency">
                                    <div class="links-container">
                                        <a
                                            v-if="agency.url_facebook"
                                            :href="agency.url_facebook"
                                            class="btn btn-contact facebook"
                                            target="_blank"
                                            rel="noopener"
                                        >
                                            <masked-image src="/img/icons/ico_facebook.svg"></masked-image>
                                            <span>{{ lang.labels.facebook }}</span>
                                        </a>
                                        <a
                                            v-if="agency.url_instagram"
                                            :href="agency.url_instagram"
                                            target="_blank"
                                            rel="noopener"
                                            class="btn btn-contact instagram"
                                        >
                                            <masked-image src="/img/icons/instagram-big.svg"></masked-image>
                                            <span>{{ lang.labels.instagram }}</span>
                                        </a>
                                        <a
                                            v-if="agency.url_linkedin"
                                            :href="agency.url_linkedin"
                                            target="_blank"
                                            rel="noopener"
                                            class="btn btn-contact linkedin"
                                        >
                                            <masked-image src="/img/icons/linkedin-big.svg"></masked-image>
                                            <span>{{ lang.labels.linkedin }}</span>
                                        </a>
                                        <a
                                            v-if="agency.url_twitter"
                                            :href="agency.url_twitter"
                                            target="_blank"
                                            rel="noopener"
                                            class="btn btn-contact twitter"
                                        >
                                            <masked-image src="/img/icons/twitter-big.svg"></masked-image>
                                            <span>{{ lang.labels.twitter }}</span>
                                        </a>
                                        <a
                                            v-if="agency.active && agency.url_agency"
                                            :href="agency.url_agency"
                                            class="btn btn-contact webagency"
                                            target="_blank"
                                            rel="noopener"
                                        >
                                            <masked-image src="/img/icons/site-agency.svg" :alt="lang.labels.homepage"></masked-image>
                                            <span>{{ lang.labels.homepage }}</span>
                                        </a>
                                        <a
                                            v-if="agency.active && agency.url_sell"
                                            :href="agency.url_sell"
                                            class="btn btn-contact ml-auto sell"
                                            target="_blank"
                                            rel="noopener"
                                        >
                                            <masked-image src="/img/icons/evaluation-agency.svg" :alt="lang.labels.sell"></masked-image>
                                            <span>{{ lang.labels.sell }}</span>
                                        </a>

                                        <a
                                            :href="agency.url_site"
                                            class="btn btn-network ml-auto details"
                                            target="_blank"
                                            rel="noopener"
                                        >
                                            {{ lang.labels.details }}
                                        </a>

                                        <a
                                            :href="agency.url_site"
                                            class="btn btn-network ml-auto calculate-route"
                                            target="_blank"
                                            rel="noopener"
                                        >
                                            <masked-image src="/img/icons/route-agency.svg" :alt="lang.labels.sell"></masked-image>
                                            {{ lang.labels.calculate_route }}
                                        </a>
                                    </div>
                                </template>
                            </slot>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="canShowTeam">
            <div>
                <div class="agency-team">
                    <h4 class="agency-team-title">
                        <img src="/img/icons/agency-team.svg" />
                        {{ lang.labels.team }}
                    </h4>

                    <agency-team-carousel
                        :per-page="teamPerPage"
                        :team="agency.team"
                    />
                </div>
            </div>
        </div>
    </div>
    </div>

</template>

<script>
import DistanceBar from './DistanceBar'
import IconBox from './IconBox'
import ModalOpener from '../ModalOpener'
import TeamCarousel from './TeamCarousel'
import Tooltip from '../Tooltip.vue'
import AppointmentForm from '../AppointmentForm'
import Modal from '../Modal'

export default {

    components: {
        'agency-team-carousel': TeamCarousel,
        'distance-bar': DistanceBar,
        'icon-box': IconBox,
        'modal-opener': ModalOpener,
        'tooltip': Tooltip,
        'appointment-form': AppointmentForm,
        'modal': Modal,
        
    },

    props: {
        agency: {
            type: Object,

            default() {
                return {
                    address: null,
                    telephone: null,
                    district: null,
                    business_name: null,
                    email: null,
                    url_facebook: null,
                    url_agency: null,
                }
            },

            required: false,
        },

        network: {
            type: String,
            default:'',
            required: false
        },

        showEmail: {
            type: Boolean,
            default: true,
        },

        maxDistance: {
            type:Number,
            required: false,
        },

        teamPerPage: {
            type: Array,
            required: false,
        },

        trackPhone: {
            type: Boolean,
            default:false,
        },

        estateId: {
            type: Number,
            required: false,
        },

        estateType: {
            type: String,
            required: false,
        },

        closeButton: {
            type: Boolean,
            required: false,
        },
    },

    data() {
        return {
            showPhone: ! this.trackPhone,
            track_phone: false
        }
    },

    filters: {
        capitalize(value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.toLowerCase().slice(1)
        }
    },

    computed: {
        isActive() {
            let allowed_statuses = ['ATTIVO', 'PRE_SOSPESO']

            return allowed_statuses.includes(this.agency.status)
        },

        canShowLeadForm() {
            return ! this.isActive && this.agency.email && this.showEmail
        },

        // canShowPhone() {
        //     return this.agency.phone
        //     // return this.isActive && this.agency.phone
        // },

        phoneToShow() {
            return this.isActive ? this.agency.phone : (this.agency.phone_real ?? this.agency.phone)
        },

        canShowTeam() {
            return this.agency.team && this.agency.team.length && this.isActive
        },

        lang() {
            return this.$root.lang.agency_card
        },

        networkClass() {
            return this.agency.network === 'tre' ? 'tecnorete' : 'tecnocasa'
        },

        detailLink() {
            let link = this.$root.lang['routes.agencies.show']

            if (link) {
                link = link.replace('{sector}', this.lang.sector[this.agency.sector])
                link = link.replace('{province}', this.agency.province.slug)
                link = link.replace('{city}', this.agency.city.slug)
                link = link.replace('{id}', this.agency.id)
                return link
            } else {
                return false
            }
        },

        percentage() {
            return this.maxDistance ? (this.agency.absolute_distance * 100) / this.maxDistance : 0
        },

        has_header_slot() {
            return !!this.$slots.header
        }
    },

    methods: {
        savePhoneView() {
            axios.post('/api/agencies/save-phone-view', {
                type: this.estateType,
                estateId: this.estateId,
                agencyId: this.agency.id,
                userHash: this.$root.user_hash
            })
            .then((data) => {})
        },

        track(type) {

            if (type == 'phone') {
                this.showPhone = true
                this.savePhoneView()
            }
            
            if (window.trackLibrary && this.track_phone == false && this.estateType == 'estate') {
                setTimeout(() =>
                    window.trackLibrary.track('actions.telefonoImmobile', {
                        immobile_id: this.estateId,
                        agenzia_id: this.agency.id,
                        tipoPagina: 'telefono',
                        nazione: this.agency.country,
                        origine: (window.location.search.substr(1).split('&').indexOf('origine=newsletter') !== -1) ? 'newsletter' : 'portale'
                    }),
                    100
                )
                this.track_phone = true
            }
        },

        closeCard() {
            window.events.$emit('agencyCardclose')
        },

        openAppointmentModal() {
            window.events.$emit('showModal', { name: 'appointment_estate' })
        },        
    }
}
</script>